export const pushToDataLayer = (payload: Record<string, unknown>): boolean => {
	if (typeof window === 'undefined') return false
	if (!Array.isArray(window.dataLayer)) return false

	window.dataLayer.push(payload)

	return true
}
